import { AdvancedAnalysisChat } from '@/components/AdvancedAnalysisChat';
import { usePageTitle } from '@/hooks/usePageTitle';
import { useParams } from 'react-router-dom';

export const AdvancedAnalysisPage = () => {
  usePageTitle('Advanced Analysis');
  const { assetId } = useParams();
  return <AdvancedAnalysisChat assetId={assetId} />;
};
